import getFiltersOption from '../store/store';
import { discardFiltersOption } from '../actions/internalActions';
import { mutator } from 'satcheljs';

export default mutator(discardFiltersOption, () => {
    let filtersOption = getFiltersOption();
    filtersOption.contactsTrusted = null;
    filtersOption.trustedListsOnly = null;
    filtersOption.blockContentFromUnknownSenders = null;
});
